import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetNetworksPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/inputs/get-networks-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchNetworkListContext } from '../../network.context';
import { NetworkListFilterSearchFormStep1Controller } from '../network-list-filter-search-form-step-1/network-list-filter-search-form-step-1.controller';

export interface NetworkListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetNetworksPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetNetworksPaginatedModel>;
  onCancel: () => void;
}

export const NetworkListFilterSearchFormController = (
  props: NetworkListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchNetworkListContext();

  return (
    <HeadlessFormProvider<GetNetworksPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <NetworkListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
